import {
  LayoutDashboard,
  Factory,
  FlaskConical,
  TestTubes,
  Beaker,
  FolderKanban,
  Gauge,
  Briefcase,
  Wrench,
  Construction,
  type LucideIcon,
} from "lucide-react";

/**
 * #914 Cloudflare-style nav: ONE icon per top-level module (section) — sub-pages are
 * text-only. Shared by the Sidebar (module headers, collapsed rail) and the command
 * palette (each page row shows its section's icon), so it lives here rather than in
 * either component (Sidebar imports the palette's opener — a palette import of
 * Sidebar would be a cycle). Every SIDEBAR_SECTIONS key must have an entry; the
 * coverage test (tests/route-catalog-coverage.test.ts) locks the two together so a
 * new section can't ship an icon-less (invisible-when-collapsed) module.
 */
export const SECTION_ICONS: Record<string, LucideIcon> = {
  overview: LayoutDashboard,
  production: Factory,
  quality: FlaskConical,
  lab: TestTubes,
  rd: Beaker,
  projects: FolderKanban,
  analytics: Gauge,
  commercial: Briefcase,
  tools: Wrench,
  internal: Construction,
};
